module.exports = __webpack_public_path__ + "img/icon-tick.e94072c3.svg";